export default __webpack_public_path__ + "static/media/icon-insights-performance-support-sessions.a03fc49c.svg";